/**
 * Shallow comparison utility for arrays and objects
 */
export function shallowEqualArrays<T>(a: T[], b: T[]): boolean {
	if (a.length !== b.length) return false;
	for (let i = 0; i < a.length; i++) {
		if (a[i] !== b[i]) return false;
	}
	return true;
}

/**
 * Shallow comparison for filter objects
 */
export function shallowEqualFilters(a: Array<{ type: string; value: any[] }>, b: Array<{ type: string; value: any[] }>): boolean {
	if (a.length !== b.length) return false;
	for (let i = 0; i < a.length; i++) {
		if (a[i].type !== b[i].type) return false;
		if (a[i].value.length !== b[i].value.length) return false;
		for (let j = 0; j < a[i].value.length; j++) {
			if (a[i].value[j] !== b[i].value[j]) return false;
		}
	}
	return true;
}
